import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDate, OUTCOMES } from "@/lib/constants";
import { OutcomeBadge } from "@/components/StatusBadge";

export default function Assessments() {
  const [outcome, setOutcome] = useState("");
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/assessments", { params: { outcome: outcome || undefined } }).then((r) => setItems(r.data));
  }, [outcome]);

  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">Records</p>
        <h1 className="mt-1 text-3xl font-extrabold tracking-tight sm:text-4xl">Assessments</h1>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {["", ...Object.keys(OUTCOMES)].map((o) => (
          <button key={o || "all"} data-testid={`assessment-filter-${o || "all"}`} onClick={() => setOutcome(o)}
            className={`whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium ${outcome === o ? "border-primary bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
            {o ? OUTCOMES[o].label : "All"}
          </button>
        ))}
      </div>
      <div className="overflow-hidden rounded-2xl border bg-card" data-testid="assessments-list">
        {items === null && <div className="h-24 animate-pulse" />}
        {items?.length === 0 && <p className="px-5 py-10 text-sm text-muted-foreground">No assessments found.</p>}
        {items?.map((a) => (
          <Link key={a.id} to={`/assessments/${a.id}`} data-testid={`assessment-row-${a.id}`} className="flex items-center justify-between gap-3 border-b px-5 py-4 last:border-0 hover:bg-secondary/50">
            <div className="min-w-0">
              <div className="truncate font-semibold">{a.rider_name}</div>
              <div className="text-xs text-muted-foreground">{fmtDate(a.date)} · {a.assessment_type === "initial" ? "Initial" : "Re-assessment"} · {a.assessor_name}</div>
            </div>
            <div className="flex flex-col items-end gap-1">
              <OutcomeBadge outcome={a.outcome} />
              {a.outcome === "referred" && <span className="text-[11px] text-muted-foreground">{a.review ? "Decision recorded" : "Awaiting decision"}</span>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
